import {Stack, Text, buttonStyles, Inline} from '@treatwell/ui';
import styles from './Error.module.css';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../hooks/store';
import {selectVenueData} from '../store/slices/venue/slice';
import clsx from 'clsx';

type Props = {
  labels: {
    header: string;
    description: string;
    cta: string;
  };
  href: string;
};

export const Error = ({labels, href}: Props) => {
  const linkStyles = clsx(
    buttonStyles.button,
    buttonStyles.secondary,
    buttonStyles.lg,
    styles.link,
  );

  return (
    <div className={styles.container} data-cy="Error-container">
      <Stack align="center" space="xl">
        <Stack space="2md" align="center">
          <Text type="smHero" as="h1">
            {labels.header}
          </Text>
          <Text type="lgHeader" as="p">
            {labels.description}
          </Text>
        </Stack>
        <a href={href} className={linkStyles} data-cy="GoBackLink">
          <Inline justify="center" space="md">
            <Text type="mdHeader">{labels.cta}</Text>
          </Inline>
        </a>
      </Stack>
    </div>
  );
};

export const GenericError = () => {
  const {t} = useTranslation();
  const header = t('error.header');
  const description = t('error.body');
  const {name, uri} = useAppSelector(selectVenueData);
  let cta, href;

  if (name.length && uri.length) {
    cta = t('error.cta.venue', {venueName: name});
    href = uri;
  } else {
    cta = t('error.cta.homepage');
    href = '/';
  }

  return (
    <Error
      labels={{
        header,
        description,
        cta,
      }}
      href={href}
    />
  );
};

GenericError.displayName = 'GenericError';
